import { render, staticRenderFns } from "./partnerPrintRemittance.vue?vue&type=template&id=22c1d0bb&scoped=true&"
import script from "./partnerPrintRemittance.vue?vue&type=script&lang=js&"
export * from "./partnerPrintRemittance.vue?vue&type=script&lang=js&"
import style0 from "./partnerPrintRemittance.vue?vue&type=style&index=0&id=22c1d0bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c1d0bb",
  null
  
)

export default component.exports